import { clamp, damp } from '../util/math';
import type { CollectibleTier } from '../levels/types';

// Panda mood (0 = sad, 1 = happy). Rises when the panda is fed (fruit/food) or
// gets a hóngbāo/coin; falls when it hits things it shouldn't or takes a tumble.
// Because pickups also drive the score, mood roughly tracks how well you're doing.

const FEED: Record<CollectibleTier, number> = {
  fruit: 0.015,
  food: 0.06,
  coin: 0.09,
  envelope: 0.16,
};

export class Mood {
  /** Smoothed, displayed value. Starts empty and fills as you do well. */
  value = 0;
  private target = 0;

  reset(): void {
    this.value = 0;
    this.target = 0;
  }

  feed(tier: CollectibleTier): void {
    this.target = clamp(this.target + FEED[tier], 0, 1);
  }

  /** Something bad happened (obstacle hit, bamboo, fall…). */
  upset(amount: number): void {
    this.target = clamp(this.target - amount, 0, 1);
  }

  update(dt: number): void {
    this.value = damp(this.value, this.target, 3.5, dt);
  }
}
